import { Form, Formik } from 'formik'
import Styles from './Review.module.scss'

import { Button } from 'blaze-ui/Button'
import * as yup from 'yup'
import { ReviewProps } from './Types'
import { ThemeField } from './ThemeField'
import { AudienceField } from './AudienceField'
import { GoalField } from './GoalField'
import { DescriptionField } from './DescriptionField'
import { CallToActionField } from './CallToActionField'
import { TargetLinkField } from './TargetLinkField'
import { ModalSubmitContainer } from 'screens/Campaigns/components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalSubmitContainer'

export const validationScheme = yup.object().shape({
  theme: yup.string().required('Please enter a theme for the campaign'),
  description: yup.string().required('Please enter a description for the campaign'),
  goal: yup.string().required('Please enter a goal for the campaign'),
})

export const ReviewForm = () => (
  <Form className={Styles.form}>
    <ThemeField />
    <AudienceField />
    <GoalField />
    <DescriptionField />
    <CallToActionField />
    <TargetLinkField />
  </Form>
)

export const Review = ({ theme, audience, callToAction, description, goal, onNext, targetLink }: ReviewProps) => {
  return (
    <Formik
      validationSchema={validationScheme}
      initialValues={{
        theme,
        audience,
        callToAction,
        targetLink,
        description,
        goal,
      }}
      onSubmit={(values) => onNext(values)}
    >
      {({ submitForm }) => (
        <>
          <ReviewForm />
          <ModalSubmitContainer>
            <Button size="lg" onPress={() => submitForm()}>
              Continue
            </Button>
          </ModalSubmitContainer>
        </>
      )}
    </Formik>
  )
}
